/*
 * dev (context)
 */
import { createContext } from "react"

type DevState = {
	debugMode: boolean
	setDebugMode: (debugMode: boolean, showToast?: boolean) => void
	devMode: boolean
	setDevMode: (devMode: boolean, showToast?: boolean) => void
}

const initialState: DevState = {
	debugMode: false,
	setDebugMode: () => null,
	devMode: false,
	setDevMode: () => null,
}

export const DevContext = createContext<DevState>(initialState)
